import styled from "styled-components";
import {ACTIVE} from "../../../../themes/css-global-classes";

export const PanicButtonBox = styled.div`
    width: 15.7rem;
    height: 2.7rem;
    background: url("${props => props.theme.images.germanyPanicButton.toString()}") center center / 100% 100% no-repeat;

    &.${ACTIVE} {
      &::after{
        display: block;
      }
    }

    &::before {
        content: '';
        display: inline-block;
        position: relative;
        top: 2.1rem;
        width: 15rem;
        height: 0.6rem;
        background: transparent;
    }

    &::after{
        display: none;
        content: " ";
        position: relative;
        left: 3rem;
        top: 0.7rem;
        width: 1px;
        border-width: 5px;
        border-style: solid;
        border-color: transparent transparent ${({theme}) => theme.colors.buttonLight} transparent;

        @media ${({theme}) => theme.mediaQuery.sAndBelow}{
            @media ${({theme}) => theme.mediaQuery.portrait}{
                  left: 7.5rem;
            }
        }
    }
`;
